module.exports = __webpack_public_path__ + "static/media/主页面[新]_04.5738dd1c.jpg";